import React from 'react'

// graphql
import { useQuery } from '@apollo/client'
import { GET_JOB_DAY_BY_ID_WITH_JOB_INFO } from '../../../../../graphql/jobDay/jobDay.queries'

// components
import Card from '../../../../../components/cards/Card/Card.component'
import CardDataPoint from '../../../../../components/cards/CardDataPoint/CardDataPoint.component'

export default function JobInfo({ jobDayId }) {

    let jobDay = {job: {}}

    const { data } = useQuery(GET_JOB_DAY_BY_ID_WITH_JOB_INFO, {
        variables: { id: jobDayId }
    })

    if(data && data.jobDay) {
        jobDay = {
            ...data.jobDay,
        }
    }

    return (<Card header={{ icon: null, title: 'Job'}}>
        
        <CardDataPoint label='Number' value={jobDay.job.id} />
        <CardDataPoint label='Address' value={jobDay.job.street1 ? [`${jobDay.job.street1}`, `${jobDay.job.city}, ${jobDay.job.state} ${jobDay.job.zipcode}`] : null} />
        <CardDataPoint label='Truck' value={jobDay.truck ? jobDay.truck.number : ""} />
        <CardDataPoint label='Driver' value={jobDay.driver ? `${jobDay.driver.firstName} ${jobDay.driver.lastName}` : ""} />
        <CardDataPoint label='Scope' value={jobDay.scopeOfWork} />

    </Card>)
}